module.exports = __webpack_public_path__ + "img/product__camera__icon.07f0d7eb.svg";